import { useMantineTheme } from "@mantine/core";
import { ButtonToggleV1 } from "./ButtonToggleV1";
import { ButtonToggleV2 } from "./ButtonToggleV2";

export interface ButtonToggleProps {
  value?: boolean;
  onChange: (value?: boolean) => void;
  trueLabel: string;
  falseLabel: string;
  align?: "left" | "center" | "right";
  error?: string;
}

export const ButtonToggle = (props: ButtonToggleProps) => {
  const theme = useMantineTheme();

  return theme.other.version === "v2" ? (
    <ButtonToggleV2 {...props} />
  ) : (
    <ButtonToggleV1 {...props} />
  );
};
